<template>
    <div class="login-container">
        <div class="login-dialog">
            <div class="login-header">
                <h2>登 录</h2>
            </div>
            <form @submit.prevent="handleLogin" class="login-form">
                <div class="form-group">
                    <label for="username">用户名</label>
                    <input type="text" id="username" v-model="loginForm.username" placeholder="请输入用户名" required />
                </div>
                <div class="form-group">
                    <label for="password">密码</label>
                    <input type="password" id="password" v-model="loginForm.password" placeholder="请输入密码" required />
                </div>
                <div class="form-actions">
                    <button type="submit" class="login-btn" :disabled="loading">
                        {{ loading ? '登录中...' : '登 录' }}
                    </button>
                    <button type="button" class="register-btn" @click="goToRegister">
                        注 册
                    </button>
                </div>
                <div v-if="errorMessage" class="error-message">
                    {{ errorMessage }}
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AuthService from '@/services/authService'

export default {
    name: 'UserLogin',
    data() {
        return {
            loginForm: {
                username: '',
                password: ''
            },
            loading: false,
            errorMessage: ''
        }
    },
    methods: {
        async handleLogin() {
            this.loading = true
            this.errorMessage = ''

            try {
                const response = await AuthService.login(
                    this.loginForm.username,
                    this.loginForm.password
                )

                if (response.status === 200) {
                    // 登录成功
                    console.log('登录成功:', response)

                    // 保存用户信息
                    const userInfo = {
                        userid: response.userid,
                        nickname: response.nickname,
                        icon: response.icon,
                        username: this.loginForm.username
                    }
                    AuthService.setUserInfo(userInfo)

                    // 跳转到主页
                    this.$router.push('/')
                } else {
                    // 登录失败
                    this.errorMessage = response.message || '登录失败'
                }
            } catch (error) {
                console.error('登录错误:', error)
                this.errorMessage = '登录失败，请检查用户名和密码'
            } finally {
                this.loading = false
            }
        },
        goToRegister() {
            // 这里可以跳转到注册页面，暂时留空
            console.log('跳转到注册页面')
        }
    }
}
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.login-dialog {
    width: 100%;
    max-width: 400px;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.login-header {
    text-align: center;
    margin-bottom: 20px;
}

.login-header h2 {
    margin: 0;
    color: #333;
}

.login-form {
    display: flex;
    flex-direction: column;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
}

.form-group input:focus {
    outline: none;
    border-color: #42b983;
}

.form-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.login-btn,
.register-btn {
    padding: 12px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.login-btn {
    background-color: #42b983;
    color: white;
}

.login-btn:hover:not(:disabled) {
    background-color: #359c6d;
}

.login-btn:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
}

.register-btn {
    background-color: #f0f0f0;
    color: #333;
}

.register-btn:hover {
    background-color: #e0e0e0;
}

.error-message {
    color: #ff6b6b;
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
}
</style>